import { LANGUAGE } from "@/common/utils/constants.js";

export const AKKODIS_SOLUTION_DOCX = {
	[LANGUAGE.en.short]: {
		title: `Akkodis Solution`
	},
	[LANGUAGE.de.short]: {
		title: `Akkodis-Lösung`
	},
	[LANGUAGE.fr.short]: {
		title: `Solution Akkodis`
	},
	[LANGUAGE.it.short]: {
		title: `Soluzione Akkodis`
	},
	[LANGUAGE.ja.short]: {
		title: `アッコディスソリューション`
	},
	[LANGUAGE.es.short]: {
		title: `Solución Akkodis`
	}
}
